import React from 'react';
import { PriceLabel, TableItemActionsNew } from 'components';
const columns = (actionsList, setSelectedInvoice, setIsPaymentLinkOpen, setIsOpenDialog , currencyText) => [
  {
    title: 'شناسه فاکتور',
    field: 'invoiceId', // 1356
    align: 'center',
  },
  {
    title: 'تاریخ صدور',
    field: 'issueDate',
    render: (rowData) => (
      <div>
        <bdi style={{ direction: 'ltr' }}>
          {rowData.issueDate} {rowData.issueTime}
        </bdi>
      </div>
    ),
  },
  {
    title: 'شناسه ارجاع',
    field: 'refrenceId', // 1360
    align: 'center',
  },
  {
    title: `قابل پرداخت (${currencyText})`,
    field: 'amountPayable', // 1357 and 1358
    align: 'center',
    render: (rowData) => (
      <PriceLabel amount={rowData.amountPayable} />
    ),
  },
  {
    title: 'تاریخ پرداخت',
    field: 'dateOfPayment',
    align: 'center',
    render: (rowData) => (
      <div>
        <bdi style={{ direction: 'ltr' }}>
          {rowData.dateOfPayment} {rowData.timeOfPayment}
        </bdi>
      </div>
    ),
  },
  {
    title: 'وضعیت فاکتور',
    field: 'invoiceStatus', // 1359
    align: 'center',
  },
  {
    title: 'نام کسب‌وکار',
    field: 'businessName', // 1361
    align: 'center',
    // defaultFilter: getUrlParameter('guild-name') || '',
  },
  {
    title: 'نوع پرداخت',
    field: 'paymentType', // 1362
    align: 'center',
    render: (rd) => rd.paymentType || '-',
  },
  ...(actionsList['invoiceCreditorDetailFinancialPage'] ||
    actionsList['paymentInvoiceCreditorFinancialBtn'] ||
    actionsList['paymentLinkInvoiceCreditorFinancialBtn']
  ) ? [{
    title: 'عملیات',
    field: 'operationSmall',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <TableItemActionsNew
        iconButton
        title=""
        otherMenus={[
          {
            title: 'جزییات',
            isShow: !!actionsList['invoiceCreditorDetailFinancialPage'] , 
            onClick: () => window.open(`/Invoice/${rowData.invoiceId}/details`),
          },
          {
            title: 'لینک پرداخت',
            isShow: !!actionsList['paymentLinkInvoiceCreditorFinancialBtn'],
            onClick: () => {
              setSelectedInvoice(rowData);
              setIsPaymentLinkOpen(true);
            },
            disabled: rowData?.invoiceStatus === 'پرداخت شده' || !!rowData?.paymentType,
          },
          {
            title: 'پرداخت با حساب دیجیتال',
            isShow: !!actionsList['paymentInvoiceCreditorFinancialBtn'],
            onClick: () => {
              setSelectedInvoice(rowData);
              setIsOpenDialog(true);
            },
            disabled: rowData?.invoiceStatus === 'پرداخت شده' || !!rowData?.paymentType,
          },


        ]}
      />
    ),
  }] : [],









];

const columnsId = {
  invoiceId: '1356',
  refrenceId: '1360',
  tax: '1451',
  invoiceStatus: '1359',
  businessName: '1361',
  paymentType: '1362',
};

export { columns, columnsId };
